"use client";
import { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { curPostCodeOrAddress } from "@/utils/addressRequestUtils";
import { getAddressStore } from "@/components/address/AddressStore";

import ArrowIcon from "@/images/icon/arrow-default.svg";

import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";

import { DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UKDialog from "@/components/UKDialog";
import AddressSelectDrawer from "@/components/address/AddressSelect/AddressSelectDrawer";
import { useTranslation } from "@/i18n/client";
import LocationSvg from "@/assets/icons/dp-location.svg";
import { AddressSelectorWrapper } from "@/styles/product";
function AddressSelector({ floors, skuId }: any) {
  const { t } = useTranslation();
  const addressStore = getAddressStore();
  const postCode = addressStore.detailPostCode.get();
  const [isClient, setIsClient] = useState(false);
  const productShipPromiseFloor = floors.productShipPromiseFloor?.data;

  const { promise, freightThresholdText } = productShipPromiseFloor?.["C-M#viewAddressItem&addressCore"] || {};
  useEffect(() => {
    setIsClient(true);
  }, []);

  const [isOpenDialog, setIsOpenDialog] = useState(false);

  useEffect(() => {
    initPostCode();
  }, []);

  const initPostCode = async () => {
    const postCode = await curPostCodeOrAddress();
    const detailPostCode = await curPostCodeOrAddress(true);
    addressStore.setPostCode(postCode);
    addressStore.setDetailPostCode(detailPostCode);
  };

  const handlerDeliver = () => {
    sendClickTrack.Productdetail_SZFloor_Click({
      mainskuid: skuId,
    });
    setIsOpenDialog(true);
  };

  const postCodeSplitted = postCode.replaceAll(t("dp.deliverTo"), "");

  return (
    <AddressSelectorWrapper className="address-selector">
      {
          <div
            className="deliver-frame"
            exptag={"exp|" + EXPOSURE_RECORD.Productdetail_SZFloor_Expo}
            data-exptag-config={dataExpTagConfig}
            data-exptag-json-param={JSON.stringify({ mainskuid: skuId })}
          >
          <div className="update-postcode" onClick={handlerDeliver}>
            <span className="col">
              <LocationSvg />
              <strong>{postCodeSplitted}</strong>
            </span>

            <p className="arrow-right">
              <ArrowIcon />
            </p>
          </div>
          { (
            promise || freightThresholdText
          ) && <div className="intro">
            {
              promise && <div className="promise" dangerouslySetInnerHTML={{ __html: promise }} />
            }
            {
              isClient && freightThresholdText && <div 
                dangerouslySetInnerHTML={{ __html: freightThresholdText }} 
              />
            }
          </div>}
          
        </div>
        }
        <AddressSelectDrawer
          openDrawer={isOpenDialog}
          setOpenDrawer={setIsOpenDialog}
        />
    </AddressSelectorWrapper>
  );
}
export default observer(AddressSelector); // 导出被 observer 包裹后的组件

